<script lang="ts">
    import type {UserAccountReactivePageData, UserAccountStaticPageData} from '../types';
    import {getLocalization} from 'core/svelte-context/context';
    import {getPageContext} from 'shared/layouts/page-context';
    import KpLinksMenu from 'shared/components/kp-links-menu/KpLinksMenu.svelte';
    import KpButtonStyleAnchor from 'shared/ui-widgets/button/KpButtonStyleAnchor.svelte';
    import IconedContent from 'shared/ui-widgets/uicons/IconedContent.svelte';

    const localize = getLocalization();
    const pageContext = getPageContext<UserAccountStaticPageData, UserAccountReactivePageData>();

    const detailView = pageContext.staticData.detailView;
</script>

<div class="kp-user-account-search-history-and-export-part upperFooter">
    <KpButtonStyleAnchor buttonSize="sm" href="/search-history">
        <IconedContent icon="search">
            {localize(/* @kp-localization hledani.ZobrazitHledaneDotazy */ 'hledani.ZobrazitHledaneDotazy')}
        </IconedContent>
    </KpButtonStyleAnchor>

    <KpLinksMenu links="{detailView.exportLinks}"
                 dropdownButtonText="Export"
                 showIfEmpty="{false}"
                 buttonSize="sm"
                 icon="file-export"
                 additionalClasses="export-btn user-export"/>
</div>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";

    .kp-user-account-search-history-and-export-part {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: @spacing-s;
    }

    .upperFooter {
        margin-top: 0;
    }
</style>